import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	width: 100%;

	.form {
		width: 100%;
		margin: 2em 0;
		display: flex;
		flex-flow: column wrap;
		place-items: center;

		.form-input-row {
			flex-flow: column wrap;
			max-width: 35%;
			gap: 0.5em;
		}

		.submit-button {
			margin: 2em 0;
			justify-content: flex-start;
		}

		.button-password-visible {
			.button {
				padding: 0;
				max-height: 2.8em;
				background-color: transparent;
				border: 0;
			}

			.button-icon-wrapper {
				padding: 0 0.1em;
				margin: 0.2em 0 0 0;

				.icon {
					padding: 0 0.2em;
				}
			}
		}

		.token-error {
			color: ${vars.colorError};
			font-weight: 600;

			&::first-letter {
				text-transform: capitalize;
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.form {
			width: 100%;

			.form-input-row {
				max-width: 100%;
				padding: 1em;
			}

			.submit-button {
				font-size: 1.2em;
			}

			.token-error {
				font-size: 1.5em;
			}
		}
	}
`;
